import { render, staticRenderFns } from "./SlotsListing.vue?vue&type=template&id=f0187a94"
import script from "./SlotsListing.vue?vue&type=script&lang=js"
export * from "./SlotsListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports